import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSpinner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="#CBCBCB"
      fillRule="evenodd"
      d="M35.3 12.7c-3.26-3.26-7.88-5.14-12.96-4.62-7.34.74-13.38 6.7-14.2 14.04C7.04 31.82 14.54 40 24 40c6.38 0 11.86-3.74 14.42-9.12.64-1.34-.32-2.88-1.8-2.88-.74 0-1.44.4-1.76 1.06-2.26 4.86-7.68 7.94-13.6 6.62-4.44-.98-8.02-4.6-8.96-9.04C10.62 18.88 16.52 12 24 12c3.32 0 6.28 1.38 8.44 3.56 0 0 1.375 1.248 2.67.28 1.294-.967.19-3.14.19-3.14"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSpinner;
